// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"93":"1d6741aa","110":"1d39c665","279":"722f0116","545":"d2009bfb","686":"d4a74676","728":"383d3cea","801":"1d6741aa"}[chunkId] + ".chunk.css";
};